import { render, staticRenderFns } from "./BasicTimeZone.vue?vue&type=template&id=7f7bac26&"
import script from "./BasicTimeZone.vue?vue&type=script&lang=ts&"
export * from "./BasicTimeZone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports